module.exports = __webpack_public_path__ + "media/images/bg-line-dotted-4ef546e5dc698547f23d3057c243d71c.png";